/* eslint-disable react/prop-types, react/no-unused-prop-types -- props are typed via TypeScript; the rules cannot resolve inline column renderers */
import React from 'react';
import EasyUploadLink from '@features/EasyUploadLink';
import { InlineNotification, Table, TableSize, Tag, Text } from '@ui';
import RowActions from './RowActions';
import { formatDuration, formatTime12h } from './formatters';
import { t } from './translate';
import { VisitPriority } from './types';
function VisitsTable({ rows, subcontractorsEnabled, showPriority, canEdit, assigneeName, onEdit, onRemove }) {
    const columns = [
        {
            dataKey: 'scheduledDate',
            label: t('scheduled_date'),
            columnType: 'primary',
            renderer: ({ item }) => (React.createElement("div", { className: "visits-section__date" },
                React.createElement(Text, { variant: "body" }, item.scheduledDate),
                item.primary && React.createElement(Tag, { label: t('primary'), variant: "gray", colorStyle: "solid", readOnly: true })))
        },
        {
            dataKey: 'scheduledTime',
            label: t('scheduled_time'),
            renderer: ({ item }) => React.createElement(Text, { variant: "body" }, formatTime12h(item.scheduledTime))
        },
        {
            dataKey: 'assignee',
            label: subcontractorsEnabled ? t('technician_or_subcontractor') : t('technician'),
            renderer: ({ item }) => {
                var _a;
                return (React.createElement("div", { className: "visits-section__assignee" },
                    React.createElement(Text, { variant: "body" }, assigneeName(item)),
                    item.techRole && (React.createElement(Text, { variant: "body", as: "i", className: "visits-section__assignee-role" }, item.techRole)), (_a = item.errors) === null || _a === void 0 ? void 0 :
                    _a.map((message) => (React.createElement(InlineNotification, { key: message, variant: "error" }, message)))));
            }
        },
        {
            dataKey: 'duration',
            label: t('duration'),
            renderer: ({ item }) => React.createElement(Text, { variant: "body" }, formatDuration(item.duration))
        },
        ...(showPriority
            ? [
                {
                    dataKey: 'priority',
                    label: t('priority'),
                    renderer: ({ item }) => (React.createElement(Text, { variant: "body" }, item.priority === VisitPriority.HIGH ? t('priorities.high') : t('priorities.normal')))
                }
            ]
            : []),
        {
            dataKey: 'actions',
            label: '',
            width: '1px',
            align: 'right',
            columnType: 'last',
            renderer: ({ item }) => (React.createElement("div", { className: "visits-section__actions" },
                item.easyUploadProps && (React.createElement(EasyUploadLink, { subcontractWorkStatusId: item.easyUploadProps.subcontractWorkStatusId })),
                canEdit && (React.createElement(RowActions, { canRemove: item.canDelete, onEdit: () => onEdit(item.key), onRemove: () => onRemove(item.key) }))))
        }
    ];
    return (React.createElement(Table, { data: rows, columns: columns, variant: "detail", size: TableSize.Full, getItemId: (row) => row.key }));
}
export default VisitsTable;
